import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Load the Tawk.to bootstrap from our own backend proxy (same origin). Tawk's
// direct bootstrap is served as `application/x-javascript`, which Chromium ORB
// blocks on a cross-origin <script>. Our proxy re-serves it as
// `application/javascript` from our origin, so a normal <script> loads cleanly.
const TAWK_SRC = `${process.env.REACT_APP_BACKEND_URL}/api/tawk/bootstrap`;

const loadTawk = () => {
  if (window.__tawkLoaded) return;
  window.__tawkLoaded = true;
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  const s = document.createElement("script");
  s.async = true;
  s.src = TAWK_SRC;
  s.charset = "UTF-8";
  document.body.appendChild(s);
};

export const TawkController = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    loadTawk();
  }, []);

  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    const apply = () => {
      const t = window.Tawk_API;
      if (!t || typeof t.hideWidget !== "function") return false;
      try {
        isAdmin ? t.hideWidget() : t.showWidget();
      } catch (e) {
        /* noop */
      }
      return true;
    };
    if (!apply()) {
      window.Tawk_API = window.Tawk_API || {};
      const prev = window.Tawk_API.onLoad;
      window.Tawk_API.onLoad = function () {
        if (typeof prev === "function") prev();
        apply();
      };
    }
  }, [pathname]);

  return null;
};

export default TawkController;
